import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { FlashUIComponent } from "../FlashUIComponent";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import DisplayObject = createjs.DisplayObject;

export class BasicPanel extends FlashUIComponent {
    private _isLocked: boolean = false;

    constructor(disp: DisplayObject) {
        super(disp);
    }

    /*override*/
    protected init(): void {
        super.init();
        this.addEventListenerOnInit();
    }

    /**
     * use Signal.add or object.addEventListener in this method
     */
    protected addEventListenerOnInit(): void {

    }

    /*override*/
    public show(): void {
        super.show();
        this.addEventListenerOnShow();
    }

    /**
     * use Signal.add or object.addEventListener in this method
     */
    protected addEventListenerOnShow(): void {

    }

    /*override*/
    public hide(): void {
        super.hide();
        this.removeEventListenerOnHide();
    }

    /**
     * use Signal.remove or object.removeEventListener in this method
     */
    protected removeEventListenerOnHide(): void {

    }

    /*override*/
    public destroy(): void {
        super.destroy();
        this.removeEventListenerOnDestroy();
    }

    /**
     * use Signal.remove or object.removeEventListener in this method
     */
    protected removeEventListenerOnDestroy(): void {

    }
    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    protected onMouseOver(event: MouseEvent): void {
        this.onCursorOver(event);
    };

    protected onMouseOut(event: MouseEvent): void {
        this.onCursorOut(event);
    };

    protected onCursorOver(event: MouseEvent): void {
    };

    protected onCursorOut(event: MouseEvent): void {
    };

    public lockPanel(): void {
        this._isLocked = true;
    }

    public unLockPanel(): void {
        this._isLocked = false;
    }

    protected get isLocked(): boolean {
        return this._isLocked;
    }

    public checkWaitingAnimState(message: string): void {
    }

}

